import { NG_API_CLIENT } from '../../services/api'
import { AccountSurveyCounter, FetchTaskParams, FetchTaskSurveyAnswerParams, TaskBasicInfo } from './model'

export const fetchAccountSurveyCounter = async (): Promise<AccountSurveyCounter> => {
  const { data } = await NG_API_CLIENT.restClient.instance
    .request({
      method: 'GET',
      url: '/task/account-survey-counter',
      data: {},
    })
    .then(response => response)
    .catch(error => error.response)

  return data
}

export const fetchTaskInfo = async (params: FetchTaskParams): Promise<TaskBasicInfo | null> => {
  const response = await NG_API_CLIENT.get('task', {
    selector: {
      fields: [
        'id',
        'name',
        'accountManagerId',
        'categoryId',
        'surveyAnswerId',
        'isSurveyPopupClosed',
        'isSurveySuccess',
        'isSurveyFormOpened',
      ],
      predicates: params.predicates,
      ordering: [
        {
          field: 'updatedAt',
          sortOrder: 'DESC',
        },
      ],
      paging: {
        limit: 1,
      },
    },
  })

  return response?.data.page.totalNumEntries ? response?.data.page.entries[0] : null
}

export const fetchTaskSurveyAnswer = async (params: FetchTaskSurveyAnswerParams) => {
  const response = await NG_API_CLIENT.get('taskSurveyAnswer', {
    selector: {
      fields: ['id', 'taskId', 'isPopupClosed', 'isSurveySuccess', 'isFormOpened'],
      predicates: [
        {
          field: 'taskId',
          operator: 'EQUALS',
          values: [params.taskId],
        },
      ],
      paging: {
        limit: 1,
      },
    },
  })

  return response?.data.page.totalNumEntries ? response?.data.page.entries[0] : null
}
